(() => {
    const containers = window.document.querySelectorAll('.js_whole-link');
    if (!containers.length) return;

    containers.forEach((container) => {
        const section = container.closest('.section');
        if (!section) return;
        const buttons = section.querySelectorAll('[data-hover-target-element]');
        if (!buttons.length) return;

        container.addEventListener('mouseover', function () {
            buttons.forEach((button) => button.classList.add('hover'));
        });
        container.addEventListener('mouseleave', function () {
            buttons.forEach((button) => button.classList.remove('hover'));
        });
    });
})();
